import { Ng1StateDeclaration } from '@uirouter/angularjs';

import * as Resolve from '../Resolve';
import { Roles } from '../../common/constants';

const states: Ng1StateDeclaration[] = [
    {
        name: 'workflowsOverview',
        url: '/workflows-overview',
        component: 'wtWorkflowsOverviewState',
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([Roles.superAdministrator, Roles.administrator, Roles.master, Roles.engineer])
        },
        data: {
            visible: false,
            sortingOrder: 10,
            isAuthenticated: true,
            isConnected: true,
            icon: 'fa-clock-o',
            displayName: 'Workflows overview',
            editRoles: [Roles.administrator, Roles.master, Roles.engineer],
            editButtonVisibility: () => false,
            subStates: ['jobsDefinition', 'emails', 'triggerAction', 'taskProgress']
        }
    }
];

export default states;